export const services = [
  {
    image: "./images/service.png",
    title: "Free Shipping",
    tagline: "From all orders over $10",
  },
  {
    image: "./images/service-02.png",
    title: "Daily Surprise Offers",
    tagline: "From all orders over $10",
  },
  {
    image: "./images/service-03.png",
    title: "Support 24/7",
    tagline: "From all orders over $10",
  },
  {
    image: "./images/service-04.png",
    title: "Affordable Prices",
    tagline: "From all orders over $10",
  },
  {
    image: "./images/service-05.png",
    title: "Secure Payments",
    tagline: "From all orders over $10",
  },
];
